import React from 'react';
import { string } from 'prop-types';

import { colors } from '@ajaibid/components';
import useRealtimeStockPrice from '@context/websocket/useRealtimeStockPrice';
import { formatPercentage } from '@ajaibid/utils';

function Changes({ code }) {
  const { data, isDataReady } = useRealtimeStockPrice(code);

  if (!isDataReady) {
    return null;
  }

  const percentage = data?.return_pct || 0;

  const formatted = formatPercentage(percentage, 2, { sign: true });
  const color = percentage > 0 ? colors.GREEN_5 : percentage < 0 ? colors.RED_5 : colors.NEUTRAL_5;

  return <span style={{ color }}>({formatted})</span>;
}

Changes.propTypes = {
  code: string.isRequired,
};

export default Changes;
